import { wrappers, reducers, selectors } from "./VRCore/wrappers";

export const JobPackWrapper = {
    view: wrappers.JobPackWrapper,
    reducer: reducers.JobPackWrapper_reducer,
    reducer_key: "JobPackWrapper_reducer",
    createSelectors: selectors.JobPackWrapper_selectors
};
